import type { Property } from '@federa/types/properties';

export function resolvePropertyAddressWithDefault(property: Property | null | undefined, defaultValue: string): string {
	if (!property) return defaultValue;
	const full = property.propertyDetails.fullAddress?.trim();
	if (full && full.length > 0) return full;
	const short = property.propertyDetails.address.trim();
	if (short && short.length > 0) return short;
	const legacyAddress = property.address?.trim();
	if (legacyAddress && legacyAddress.length > 0) return legacyAddress;
	return defaultValue;
}
